
import React, { Component } from 'react'
import Http from '../../Http';
import { isDate } from '../../helpers/isDate';
import TableBase from './Table';
import Dialog from '../dialog/Dialog';
import moment from 'moment'
import { CircularProgress } from '@material-ui/core';
import { AuthContext } from '../../context/authContext';

export interface TableField {
	label: string;
	id: string;
}
export interface TableAction {
	id: string;
	icon: string;
}
export interface Table {
	title: string;
	fields: TableField[];
	actions: TableAction[];
	rows: any[];
	rpp: number;
	total: number;
	page: number;
}
export interface TableConfig {
	dataUrl?: string,
	deleteUrl?: string,
	modUrl?: string,
	key?: string,
	deleteField?: string,
	query?: any,
}

export class TableOp {
	static Table(title: string = '', fields: TableField[] = [], actions: TableAction[] = [], rows: any[] = [], total: number = 0, rpp: number = 15, q: any = null): TableOp {
		return { title, fields, actions, rows, rpp, total, page: 0, q }
		// return new TableOp({title, fields, actions, rows, rpp, total, page: 0});
	}

	// public Page: number;
	// public RPP: number;
	// public Title: string;
	// public Fields: TableField[];
	// public Actions: TableAction[];
	// public Rows: any[];
	// public Total: number;

	// constructor(data: Table) {
	//     this.Page = data.page
	//     this.RPP = data.rpp;
	//     this.Title = data.title;
	//     this.Fields = data.fields;
	//     this.Actions = data.actions;
	//     this.Rows = data.rows;
	//     this.Total = data.total;
	// }
}

//-----------------


class TableComponent extends Component<{ history: any }, { tableData: any; dialog: any, loading: boolean }> {
	public rpp = 15;
	public page = 0;
	public q: any = null;
	public orderBy = null;
	public order = null;
	private deleteRow = null;
	public config: any | TableConfig = {};

	state = {
		tableData: TableOp.Table(),
		dialog: {},
		q: null,
		loading: false,
	}

	public async table(page = this.page, limit = this.rpp, q = this.q, orderBy = this.orderBy, order = this.order) {
		this.page = page; this.rpp = limit;
		this.setState({ loading: true })
		try {
			if (!q) {
				const urlParams = new URLSearchParams(window.location.search);
				q = urlParams.get('qt');
				let pages = urlParams.get('page');
				if (pages) {
					page = parseInt(pages);
					this.page = page;
				}
			}
			if (!this.config.dataUrl) {
				return false;
			}
			const nexo = this.config.dataUrl && this.config.dataUrl.includes('?') ? '&' : '?'
			let Res = await Http.get(`${this.config.dataUrl}${nexo}p=${page}&l=${limit}${q ? `&q=${q}` : ''}${orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`);
			Res.data.rows = Res.data.rows.map((row: any, i: any) => {
				for (let prop in row) {
					if (prop !== 'id' && prop !== 'id_unidad_transporte' && isDate(row[prop])) {
						row[prop] = moment(row[prop]).format('D/M/YYYY HH:mm');
					}
				}
				return row;
			})

			this.setState({ tableData: { ...this.state.tableData, rows: Res.data.rows, total: Res.data.total, q, page: this.page, rpp: this.rpp }, loading: false });
			return Res.data.rows;
		} catch (error) {
			console.log(error);
			this.setState({ loading: false })
		}
		return [];
	}

	tableConfig = (config: TableConfig, data: Table) => {
		this.config = config;
		this.setState({ tableData: data })
	}

	delete = async (row: any) => {
		this.deleteRow = row;
		this.setState({
			dialog: {
				title: `¿Borrar el registro ${row[this.config.deleteField]}?`,
				body: '',
				options: ['Sí', 'No'],
				show: true,
			}
		})
	}

	dialogClose = async (op: number) => {
		this.setState({ dialog: { show: false }, loading: true });
		if (op === 1) {
			let Res = await Http.post(`${this.config.deleteUrl}`, this.deleteRow);
			if (!Res.error) {
				this.table();
			}
		}
		this.setState({ loading: false });
	}

	action = (id: any, row: any, cb: any) => {
		if (id === 'edit') {
			if (cb) return cb(id, row);
			this.props.history.push(`${this.config.modUrl}/${row.id}`)
		}
		else if (id === 'delete') {
			this.delete(row)
		}
		if (cb) {
			cb(id, row);
		}
	}

	pag = (page: number, rpp: number, q = this.q) => {
		this.table(page, rpp, q);
	}

	search = (q: any) => {
		// console.log(q)
		this.q = q;
		if (q.length < 2) this.q = null;
		// if (q.length > 3)
		this.table(this.page, this.rpp, this.q);
	}

	onOrder = (orderByS: any, orderS: any) => {
		this.orderBy = orderByS;
		this.order = orderS;
		this.table(this.page, this.rpp, this.q, orderByS, orderS);
	}

	public TableRender = (props: any) => (
		<div className="table-box">
			{this.state.loading && <div className={`overlay`}><CircularProgress size={60} /></div>}
			<TableBase
				table={this.state.tableData}
				onAction={this.action}
				pag={this.pag}
				onSearch={this.search}
				onOrder={this.onOrder}
				pagination={props.pagination}
				prevUrl={props.prevUrl}
				modUrl={this.config.modUrl}
			/>
			<Dialog dialog={this.state.dialog} onClose={this.dialogClose} />
		</div>
	)
}


TableComponent.contextType = AuthContext;
export default TableComponent